<template>
  <div class="camera-chart">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <a-row style="margin-top: 10px">
            <a-col :span="8">
              <a-statistic title="学生总数" :value="total.studentCount" />
            </a-col>
            <a-col :span="8">
              <a-statistic title="人脸录入数" :value="total.studentFaceCount" />
            </a-col>
            <a-col :span="8">
              <a-statistic
                title="抓拍覆盖率"
                :precision="2"
                :value="
                  total.cameraStudentFaceCount
                    ? (total.cameraStudentFaceCount / total.studentFaceCount) * 100
                    : 0
                "
                suffix="%"
              />
            </a-col>
          </a-row>
          <a-row style="margin-top: 30px">
            <a-col :span="8">
              <a-statistic title="情绪识别次数" :value="total.cameraFaceCount" />
            </a-col>
            <a-col :span="8">
              <a-statistic title="提醒人次" :value="total.warnCount" />
            </a-col>
            <a-col :span="8">
              <a-statistic title="家长访问次数" :value="total.visitCount" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <div class="flex-align-center">
            <span style="margin-right: 5px">今日相机采集量</span>
            <span class="title-1" style="font-size: 22px">
              {{ chartData.todayStudentFaceCount }}
            </span>
          </div>
          <mini-area
            :data-source="chartData.studentFaceList"
            :chartConfig="{
              height: 200,
              padding: [40, 40, 40, 40],
            }"
            :showXAxis="true"
            y="相机采集量"
          />
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <div class="flex-align-center">
            <span style="margin-right: 5px">今日消息推送量</span>
            <span class="title-1" style="font-size: 22px">
              {{ chartData.todaySmsPushCount }}
            </span>
          </div>
          <mini-area
            :data-source="chartData.smsPushList"
            :chartConfig="{
              height: 200,
              padding: [40, 40, 40, 40],
            }"
            :showXAxis="true"
            y="消息推送量"
          />
        </a-card>
      </a-col>
      <a-col :sm="24" :md="12" :lg="12" :xl="12">
        <a-card :loading="loading" class="card-item">
          <div class="flex-align-center">
            <span style="margin-right: 5px">今日抓拍学生量</span>
            <span class="title-1" style="font-size: 22px">{{ chartData.todayStudentCount }}</span>
          </div>
          <mini-area
            :dataSource="chartData.studentList"
            :chartConfig="{
              height: 200,
              padding: [40, 40, 40, 40],
            }"
            :showXAxis="true"
            y="抓拍学生量"
          />
        </a-card>
      </a-col>
    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{ padding: '0' }">
      <div class="salesCard">
        <div class="extra-wrapper" slot="tabBarExtraContent">
          <div class="extra-item">
            <a-button
              :type="rangeType === 'today' ? 'primary' : ''"
              @click="changeRangeType('today')"
            >
              今日
            </a-button>
            <a-button
              :type="rangeType === 'week' ? 'primary' : ''"
              @click="changeRangeType('week')"
            >
              近7天
            </a-button>
            <a-button
              :type="rangeType === 'month' ? 'primary' : ''"
              @click="changeRangeType('month')"
            >
              近30天
            </a-button>
          </div>
          <a-range-picker :style="{ width: '256px' }" :value="rangeDate" @change="onRangeChange" />
        </div>
        <a-tabs
          default-active-key="1"
          size="large"
          :tab-bar-style="{ marginBottom: '24px', paddingLeft: '16px' }"
        >
          <a-tab-pane loading="true" tab="相机采集统计" key="1">
            <a-row>
              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">
                <EmptyData :dataSource="cameraData" :styleObj="{ marginTop: '50px' }">
                  <line-chart-multid
                    slot="content"
                    title="相机采集统计"
                    :height="500"
                    :fields="cameraDataFields"
                    :dataSource="cameraData"
                  />
                </EmptyData>
              </a-col>
              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list :height="500" title="各相机采集总数(覆盖人数)" :list="cameraRankList" />
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="学生采集统计" key="2">
            <a-row>
              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">
                <EmptyData :dataSource="studentFaceData" :styleObj="{ marginTop: '50px' }">
                  <line-chart-multid
                    slot="content"
                    :height="500"
                    :title="studentFaceDataTitle"
                    :fields="studentFaceDataFields"
                    :dataSource="studentFaceData"
                    :showReturnBtn="studentFaceDataLevel === 2"
                    @click="studentFaceDataClick"
                    @return="studentFaceDataReturn"
                  />
                </EmptyData>
              </a-col>
              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list
                  :height="500"
                  title="人脸采集总数(覆盖人数)"
                  :list="studentFaceRankList"
                />
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="消息推送统计" key="3">
            <a-row>
              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">
                <EmptyData :dataSource="smsPushData" :styleObj="{ marginTop: '50px' }">
                  <line-chart-multid
                    slot="content"
                    :height="500"
                    :title="smsPushDataTitle"
                    :fields="smsPushDataFields"
                    :dataSource="smsPushData"
                    :showReturnBtn="smsPushDataLevel === 2"
                    @click="smsPushDataClick"
                    @return="smsPushDataReturn"
                  />
                </EmptyData>
              </a-col>
              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list :height="500" title="消息推送总数(覆盖人数)" :list="smsPushRankList" />
              </a-col>
            </a-row>
          </a-tab-pane>
          <!--          <a-tab-pane tab="消息点击统计" key="4">-->
          <!--            <a-row>-->
          <!--              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <line-chart-multid :title="smsClickDataTitle" :fields="smsClickDataFields" :dataSource="smsClickData" :showReturnBtn="smsClickDataLevel === 2" @click="smsClickDataClick" @return="smsClickDataReturn"/>-->
          <!--              </a-col>-->
          <!--              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <rank-list :height="500" title="家长点击次数(覆盖人数),关爱名单点击总数(覆盖人数)" :list="smsClickRankList"/>-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </a-tab-pane>-->

          <a-tab-pane v-if="isShowParentVisit" tab="家长访问统计" key="5">
            <a-row>
              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">
                <EmptyData :dataSource="parentVisitData" :styleObj="{ marginTop: '50px' }">
                  <line-chart-multid
                    slot="content"
                    :height="500"
                    :title="parentVisitDataTitle"
                    :fields="parentVisitDataFields"
                    :dataSource="parentVisitData"
                    :showReturnBtn="parentVisitDataLevel === 2"
                    @click="parentVisitDataClick"
                    @return="parentVisitDataReturn"
                  />
                </EmptyData>
              </a-col>
              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list
                  :height="500"
                  title="家长访问总数(覆盖人数),关爱名单访问总数(覆盖人数)"
                  :list="parentVisitRankList"
                />
              </a-col>
            </a-row>
          </a-tab-pane>

          <!--          <a-tab-pane tab="心情灯页面点击统计" key="6">-->
          <!--            <a-row>-->
          <!--              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <line-chart-multid :title="moodClickDataTitle" :fields="moodClickDataFields" :dataSource="moodClickData" :showReturnBtn="moodClickDataLevel === 2" @click="moodClickDataClick" @return="moodClickDataReturn"/>-->
          <!--              </a-col>-->
          <!--              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <rank-list :height="500" title="家长点击总数(覆盖人数),关爱名单点击总数(覆盖人数)" :list="moodClickRankList"/>-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </a-tab-pane>-->

          <!--          <a-tab-pane tab="点击预订统计" key="7">-->
          <!--            <a-row>-->
          <!--              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <line-chart-multid :title="clickOrderDataTitle" :fields="clickOrderDataFields" :dataSource="clickOrderData" :showReturnBtn="clickOrderDataLevel === 2" @click="clickOrderDataClick" @return="clickOrderDataReturn"/>-->
          <!--              </a-col>-->
          <!--              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <rank-list :height="500" title="家长点击总数(覆盖人数),关爱名单点击总数(覆盖人数)" :list="clickOrderRankList"/>-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </a-tab-pane>-->

          <!--          <a-tab-pane tab="提交预订统计" key="8">-->
          <!--            <a-row>-->
          <!--              <a-col :xl="18" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <line-chart-multid :title="submitOrderDataTitle" :fields="submitOrderDataFields" :dataSource="submitOrderData" :showReturnBtn="submitOrderDataLevel === 2" @click="submitOrderDataClick" @return="submitOrderDataReturn"/>-->
          <!--              </a-col>-->
          <!--              <a-col :xl="6" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <rank-list :height="500" title="家长点击总数(覆盖人数),关爱名单点击总数(覆盖人数)" :list="submitOrderRankList"/>-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </a-tab-pane>-->

          <!--          <a-tab-pane tab="人脸识别率统计" key="9">-->
          <!--            <a-row>-->
          <!--              <a-col :xl="24" :lg="12" :md="12" :sm="24" :xs="24">-->
          <!--                <line-chart-multid :title="emoteDataTitle" :fields="emoteDataFields" :dataSource="emoteData" :showReturnBtn="emoteDataLevel === 2" />-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </a-tab-pane>-->
        </a-tabs>
      </div>
    </a-card>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import RankList from '@/components/chart/RankList'
import Bar from '@/components/chart/Bar'
import LineChartMultid from '@/components/chart/LineChartMultid'
import HeadInfo from '@/components/tools/HeadInfo.vue'

import Trend from '@/components/Trend'
import { getAction } from '@api/manage'

export default {
  name: 'CameraChart',
  components: {
    ATooltip,
    ACol,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    LineChartMultid,
    HeadInfo,
  },
  data() {
    return {
      loading: true,
      total: {},
      chartData: {
        todayStudentFaceCount: 0,
        todaySmsPushCount: 0,
        todayStudentCount: 0,
        studentFaceList: [],
        smsPushList: [],
        studentList: [],
        emoteList: [],
      },
      //查询数据范围
      rangeType: 'today',
      rangeDate: [],
      beginDate: '',
      endDate: '',

      //相机采集统计
      cameraData: [],
      cameraDataFields: [],
      cameraRankList: [],

      //学生采集统计
      studentFaceDataTitle: '学生采集统计',
      studentFaceDataGradeName: '',
      studentFaceDataLevel: 1,
      studentFaceData: [],
      studentFaceDataFields: [],
      studentFaceRankList: [],

      //消息推送统计
      smsPushDataTitle: '消息推送统计',
      smsPushDataGradeName: '',
      smsPushDataLevel: 1,
      smsPushData: [],
      smsPushDataFields: [],
      smsPushRankList: [],

      //家长访问统计
      isShowParentVisit: false, // 是否显示家长访问统计tab
      parentVisitDataTitle: '家长访问统计',
      parentVisitDataGradeName: '',
      parentVisitDataLevel: 1,
      parentVisitData: [],
      parentVisitDataFields: [],
      parentVisitRankList: [],

      // // 消息点击统计
      // smsClickDataTitle: "消息推送统计",
      // smsClickDataGradeName: "",
      // smsClickDataLevel: 1,
      // smsClickData:[],
      // smsClickDataFields:[],
      // smsClickRankList:[],
      // 心情灯页面点击统计
      // moodClickDataTitle: "消息推送统计",
      // moodClickDataGradeName: "",
      // moodClickDataLevel: 1,
      // moodClickData:[],
      // moodClickDataFields:[],
      // moodClickRankList:[],
      // 点击预订统计
      // clickOrderDataTitle: "消息推送统计",
      // clickOrderDataGradeName: "",
      // clickOrderDataLevel: 1,
      // clickOrderData:[],
      // clickOrderDataFields:[],
      // clickOrderRankList:[],
      // 提交预订统计
      // submitOrderDataTitle: "消息推送统计",
      // submitOrderDataGradeName: "",
      // submitOrderDataLevel: 1,
      // submitOrderData:[],
      // submitOrderDataFields:[],
      // submitOrderRankList:[],

      //人脸识别率统计
      // emoteDataTitle: "人脸识别率统计",
      // emoteDataGradeName: "",
      // emoteDataLevel: 1,
      // emoteData:[],
      // emoteDataFields:[]
    }
  },
  created() {
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
    this.checkCOpenStatus()
    this.init()
  },
  methods: {
    init() {
      //获取顶部统计数据
      // getAction('/home/top').then(res => {
      //   if (res.success) {
      //     this.total = res.result.total
      //     this.chartData.studentFaceList = res.result.studentFaceList
      //     this.chartData.smsPushList = res.result.smsPushList
      //     this.chartData.studentList = res.result.studentList
      //     this.chartData.emoteList = res.result.emoteList
      //     this.chartData.todayStudentFaceCount = res.result.studentFaceList?.[6]?.y || 0
      //     this.chartData.todaySmsPushCount = res.result.smsPushList?.[6]?.y || 0
      //     this.chartData.todayStudentCount = res.result.studentList?.[6]?.y || 0
      //   }
      // })
      this.getCardListData()

      this.getFaceStatisticByCamera()
      this.getGradeFace()
      this.getGradeFaceSms()
      this.getGradeParentVisit()
      // this.getEmote()
      // this.getGradeSmsClick()
      // this.getGradeMoodClick()
      // this.getGradeClickOrder()
      // this.getGradeSubmitOrder()
    },
    // 获取卡片列表数据
    getCardListData() {
      // 基础信息
      getAction('/home/baseTop').then((res) => {
        if (res.success) {
          this.total = res.result
        }
      })
      // 照片采集量
      getAction('/home/faceTop').then((res) => {
        if (res.success) {
          this.chartData.todayStudentFaceCount = res.result?.[6]?.y || 0
          this.chartData.studentFaceList = res.result
        }
      })
      // 抓拍学生量
      getAction('/home/studentFaceTop').then((res) => {
        if (res.success) {
          this.chartData.todayStudentCount = res.result?.[6]?.y || 0
          this.chartData.studentList = res.result
        }
      })
      // 消息推送量
      getAction('/home/messageTop').then((res) => {
        if (res.success) {
          this.chartData.todaySmsPushCount = res.result?.[6]?.y || 0
          this.chartData.smsPushList = res.result
        }
      })
    },
    //相机获取人脸数
    getFaceStatisticByCamera() {
      getAction('/home/faceStatisticByCamera', {
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.success) {
          this.cameraData = res.result.chartData
          this.cameraDataFields = res.result.gdCameraList
          this.cameraRankList = res.result.cameraStatistic
        }
      })
    },
    /**
     * 年级维度
     */
    //各年级采集人脸数
    getGradeFace() {
      getAction('/home/gradeFace', {
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.success) {
          this.studentFaceDataTitle = '各年级采集统计'
          this.studentFaceData = res.result.chartData
          this.studentFaceDataFields = res.result.gradeList
          this.studentFaceRankList = res.result.gradeFaceStatistic
        }
      })
    },
    //各年级消息推送数
    getGradeFaceSms() {
      //各年级消息推送数
      getAction('/home/gradeFaceSms', {
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.success) {
          this.smsPushDataTitle = '各年级采集统计'
          this.smsPushData = res.result.chartData
          this.smsPushDataFields = res.result.gradeList
          this.smsPushRankList = res.result.gradeFaceSmsStatistic
        }
      })
    },
    //各年级家长访问次数统计
    getGradeParentVisit() {
      getAction('/home/gradeParentVisit', {
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
        logType: 88,
      }).then((res) => {
        if (res.success) {
          this.parentVisitDataTitle = '各年级家长访问次数统计'
          this.parentVisitData = res.result.chartData
          this.parentVisitDataFields = res.result.gradeList
          this.parentVisitRankList = res.result.gradeParentVisitStatistic
        }
      })
    },
    //消息点击统计
    // getGradeSmsClick(){
    //   getAction("/home/gradeParentVisit",{
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 3,
    //     "logContent": "点击消息进入首页"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.smsClickDataTitle = "各年级家长消息点击统计"
    //       this.smsClickData = res.result.chartData
    //       this.smsClickDataFields = res.result.gradeList
    //       this.smsClickRankList = res.result.gradeParentVisitStatistic
    //     }
    //   })
    // },
    //心情灯页面点击统计
    // getGradeMoodClick(){
    //   getAction("/home/gradeParentVisit",{
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 3,
    //     "logContent": "进入购买心情灯页面"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.moodClickDataTitle = "各年级家长心情灯页面点击统计"
    //       this.moodClickData = res.result.chartData
    //       this.moodClickDataFields = res.result.gradeList
    //       this.moodClickRankList = res.result.gradeParentVisitStatistic
    //     }
    //   })
    // },
    //点击预订统计
    // getGradeClickOrder(){
    //   getAction("/home/gradeParentVisit",{
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 4,
    //     "logContent": "点击购买心情灯"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.clickOrderDataTitle = "各年级家长点击预订统计"
    //       this.clickOrderData = res.result.chartData
    //       this.clickOrderDataFields = res.result.gradeList
    //       this.clickOrderRankList = res.result.gradeParentVisitStatistic
    //     }
    //   })
    // },
    //提交预订统计
    // getGradeSubmitOrder(){
    //   getAction("/home/gradeParentVisit",{
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 4,
    //     "logContent": "点击提交预订按钮"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.submitOrderDataTitle = "各年级家长提交预订统计"
    //       this.submitOrderData = res.result.chartData
    //       this.submitOrderDataFields = res.result.gradeList
    //       this.submitOrderRankList = res.result.gradeParentVisitStatistic
    //     }
    //   })
    // },
    /**
     * 班级维度
     */
    //各班级采集人脸数
    getClassFace() {
      getAction('/home/classFace', {
        gradeName: this.studentFaceDataGradeName,
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.success) {
          this.studentFaceDataTitle = this.studentFaceDataGradeName + ' - 各班级采集统计'
          this.studentFaceData = res.result.chartData
          this.studentFaceDataFields = res.result.classList
          this.studentFaceRankList = res.result.classFaceStatistic
        }
      })
    },
    //各班级消息推送数
    getClassFaceSms() {
      getAction('/home/classFaceSms', {
        gradeName: this.smsPushDataGradeName,
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }).then((res) => {
        if (res.success) {
          this.smsPushDataTitle = this.smsPushDataGradeName + ' - 各班级消息推送统计'
          this.smsPushData = res.result.chartData
          this.smsPushDataFields = res.result.classList
          this.smsPushRankList = res.result.classFaceSmsStatistic
        }
      })
    },
    //各班级家长访问次数统计
    getClassParentVisit() {
      getAction('/home/classParentVisit', {
        gradeName: this.parentVisitDataGradeName,
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
        logType: 1,
      }).then((res) => {
        if (res.success) {
          this.parentVisitDataTitle = this.parentVisitDataGradeName + ' - 各班级家长访问次数统计'
          this.parentVisitData = res.result.chartData
          this.parentVisitDataFields = res.result.classList
          this.parentVisitRankList = res.result.classParentVisitStatistic
        }
      })
    },
    //消息点击统计
    getClassSmsClick() {
      getAction('/home/classParentVisit', {
        gradeName: this.smsClickDataGradeName,
        rangeType: this.rangeType,
        beginDate: this.beginDate,
        endDate: this.endDate,
        logType: 3,
        logContent: '点击消息进入首页',
      }).then((res) => {
        if (res.success) {
          this.smsClickDataTitle = this.smsClickDataGradeName + ' - 各班级家长消息点击统计'
          this.smsClickData = res.result.chartData
          this.smsClickDataFields = res.result.classList
          this.smsClickRankList = res.result.classParentVisitStatistic
        }
      })
    },
    //心情灯页面点击统计
    // getClassMoodClick(){
    //   getAction("/home/classParentVisit",{
    //     "gradeName": this.moodClickDataGradeName,
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 3,
    //     "logContent": "进入购买心情灯页面"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.moodClickDataTitle = this.moodClickDataGradeName+" - 各班级家长心情灯页面点击统计"
    //       this.moodClickData = res.result.chartData
    //       this.moodClickDataFields = res.result.classList
    //       this.moodClickRankList = res.result.classParentVisitStatistic
    //     }
    //   })
    // },
    //点击预订统计
    // getClassClickOrder(){
    //   getAction("/home/classParentVisit",{
    //     "gradeName": this.clickOrderDataGradeName,
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 4,
    //     "logContent": "点击购买心情灯"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.clickOrderDataTitle = this.clickOrderDataGradeName+" - 各班级家长点击预订统计"
    //       this.clickOrderData = res.result.chartData
    //       this.clickOrderDataFields = res.result.classList
    //       this.clickOrderRankList = res.result.classParentVisitStatistic
    //     }
    //   })
    // },
    //提交预订统计
    // getClassSubmitOrder(){
    //   getAction("/home/classParentVisit",{
    //     "gradeName": this.submitOrderDataGradeName,
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate,
    //     "logType": 4,
    //     "logContent": "点击提交预订按钮"
    //   }).then((res)=>{
    //     if(res.success){
    //       this.submitOrderDataTitle = this.submitOrderDataGradeName+" - 各班级家长提交预订统计"
    //       this.submitOrderData = res.result.chartData
    //       this.submitOrderDataFields = res.result.classList
    //       this.submitOrderRankList = res.result.classParentVisitStatistic
    //     }
    //   })
    // },
    //人脸识别率
    // getEmote(){
    //   //人脸识别率
    //   getAction("/home/emote",{
    //     "rangeType": this.rangeType,
    //     "beginDate": this.beginDate,
    //     "endDate": this.endDate
    //   }).then((res)=>{
    //     if(res.success){
    //       this.emoteDataTitle = "人脸识别率"
    //       this.emoteData = res.result.chartData
    //       this.emoteDataFields = []
    //       res.result.emoteList.forEach(item =>{
    //         this.emoteDataFields.push(item.itemText)
    //       })
    //       console.log(this.emoteDataFields)
    //     }
    //   })
    // },
    studentFaceDataClick(event, chart) {
      if (event.data && this.studentFaceDataLevel === 1) {
        this.studentFaceDataGradeName = event.data._origin.x
        this.studentFaceDataLevel = 2
        this.getClassFace()
      }
    },
    smsPushDataClick(event, chart) {
      if (event.data && this.smsPushDataLevel === 1) {
        this.smsPushDataGradeName = event.data._origin.x
        this.smsPushDataLevel = 2
        this.getClassFaceSms()
      }
    },
    parentVisitDataClick(event, chart) {
      if (event.data && this.parentVisitDataLevel === 1) {
        this.parentVisitDataGradeName = event.data._origin.x
        this.parentVisitDataLevel = 2
        this.getClassParentVisit()
      }
    },
    smsClickDataClick(event, chart) {
      if (event.data && this.smsClickDataLevel === 1) {
        this.smsClickDataGradeName = event.data._origin.x
        this.smsClickDataLevel = 2
        this.getClassSmsClick()
      }
    },
    // moodClickDataClick(event, chart){
    //   if(event.data && this.moodClickDataLevel === 1){
    //     this.moodClickDataGradeName = event.data._origin.x
    //     this.moodClickDataLevel = 2;
    //     this.getClassMoodClick()
    //   }
    // },
    // clickOrderDataClick(event, chart){
    //   if(event.data && this.clickOrderDataLevel === 1){
    //     this.clickOrderDataGradeName = event.data._origin.x
    //     this.clickOrderDataLevel = 2;
    //     this.getClassClickOrder()
    //   }
    // },
    // submitOrderDataClick(event, chart){
    //   if(event.data && this.submitOrderDataLevel === 1){
    //     this.submitOrderDataGradeName = event.data._origin.x
    //     this.submitOrderDataLevel = 2;
    //     this.getClassSubmitOrder()
    //   }
    // },
    //返回上级
    studentFaceDataReturn() {
      this.studentFaceDataGradeName = ''
      this.studentFaceDataLevel = 1
      this.getGradeFace()
    },
    smsPushDataReturn() {
      this.smsPushDataGradeName = ''
      this.smsPushDataLevel = 1
      this.getGradeFaceSms()
    },
    parentVisitDataReturn() {
      this.parentVisitDataGradeName = ''
      this.parentVisitDataLevel = 1
      this.getGradeParentVisit()
    },
    smsClickDataReturn() {
      this.smsClickDataGradeName = ''
      this.smsClickDataLevel = 1
      this.getGradeSmsClick()
    },
    moodClickDataReturn() {
      this.moodClickDataGradeName = ''
      this.moodClickDataLevel = 1
      this.getGradeMoodClick()
    },
    clickOrderDataReturn() {
      this.clickOrderDataGradeName = ''
      this.clickOrderDataLevel = 1
      this.getGradeClickOrder()
    },
    submitOrderDataReturn() {
      this.submitOrderDataGradeName = ''
      this.submitOrderDataLevel = 1
      this.getGradeSubmitOrder()
    },
    //修改查询范围
    changeRangeType(type) {
      this.rangeType = type
      this.rangeDate = []

      this.changeRangeData()
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates

      this.beginDate = dateString[0]
      this.endDate = dateString[1]

      this.changeRangeData()
    },
    //根据查询条件修改数据源
    changeRangeData() {
      //相机采集统计
      this.getFaceStatisticByCamera()
      //学生采集统计
      if (this.studentFaceDataLevel === 1) {
        this.getGradeFace()
      } else if (this.studentFaceDataLevel === 2) {
        this.getClassFace()
      }
      //消息推送统计
      if (this.smsPushDataLevel === 1) {
        this.getGradeFaceSms()
      } else if (this.smsPushDataLevel === 2) {
        this.getClassFaceSms()
      }
      //家长访问统计
      if (this.parentVisitDataLevel === 1) {
        this.getGradeParentVisit()
      } else if (this.parentVisitDataLevel === 2) {
        this.getClassParentVisit()
      }
      //人脸识别率
      // this.getEmote();

      // if(this.smsClickDataLevel === 1){
      //   this.getGradeSmsClick()
      // } else if(this.smsClickDataLevel === 2){
      //   this.getClassSmsClick()
      // }
      // if(this.moodClickDataLevel === 1){
      //   this.getGradeMoodClick()
      // } else if(this.moodClickDataLevel === 2){
      //   this.getClassMoodClick()
      // }
      // if(this.clickOrderDataLevel === 1){
      //   this.getGradeClickOrder()
      // } else if(this.clickOrderDataLevel === 2){
      //   this.getClassClickOrder()
      // }
      // if(this.submitOrderDataLevel === 1){
      //   this.getGradeSubmitOrder()
      // } else if(this.submitOrderDataLevel === 2){
      //   this.getClassSubmitOrder()
      // }
    },
    // 查询当前租户是否开通C端
    async checkCOpenStatus() {
      const res = await getAction('/statisticV2/c-open/status')
      const { success, result } = res
      if (success) {
        this.isShowParentVisit = result
      }
    },
  },
}
</script>

<style lang="less" scoped>
.card-item {
  height: 270px;
  margin-bottom: 20px;
  border-radius: 10px;
  /deep/ .ant-statistic-title {
    margin-bottom: 5px !important;
  }
  /deep/ .ant-statistic-content {
    font-weight: bold;
    color: #333333;
  }
}

.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;
  text-align: right;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}
</style>
